import { h } from 'preact';
import { m as motion, useTransform, useViewportScroll } from 'framer-motion';

import imgPlugins from '../../../../assets/plugins.svg';
import { IconArrowsSort, IconCornerDownLeft } from '@tabler/icons';
import { Feature } from '../../../../components';

function FeaturePluginsInfo() {
  const { scrollY } = useViewportScroll();
  const opacity = useTransform(scrollY, [2000, 2100, 3200, 3400], [0, 1, 1, 0]);

  return (
    <motion.div class="absolute" style={{ opacity }}>
      <Feature.Name className="text-green-500">
        <Feature.Icon src={imgPlugins} alt="Plugins icon" />
        Plugins
      </Feature.Name>
      <Feature.Headline className="from-green-500 to-green-800 bg-clip-text text-transparent">
        It's more than search.
      </Feature.Headline>
      <Feature.Description className="text-gray-500">
        Plugins extend the functionality of UnTab by making common actions accessible on every page.
        Want to do a quick search? close the tab? there's a plugin for it.
      </Feature.Description>
    </motion.div>
  )
}

function FeaturePluginsResult() {
  const { scrollY } = useViewportScroll();
  const searchBarY = useTransform(scrollY, [1700, 1850], [0, -30]);
  const pluginResultOpacity = useTransform(scrollY, [2000, 2200, 2600, 2700], [0, 1, 1, 0]);
  const pluginResultNavigateY = useTransform(scrollY, [2300, 2310], [0, 36]);
  const pluginResultNavigateScale = useTransform(scrollY, [2500, 2520, 2540], [1, 0.93, 1]);

  const tabActionsOpacity = useTransform(scrollY, [2700, 2900, 3200, 3400], [0, 1, 1, 0]);
  const tabActionsY = useTransform(scrollY, [2700, 2900], [0, -30]);

  return (
    <>
      <motion.div style={{ y: searchBarY, opacity: pluginResultOpacity }} className="bg-white rounded-md shadow-xl px-3 py-2 absolute top-full mt-1 left-14">
        <motion.div style={{ y: pluginResultNavigateY, scale: pluginResultNavigateScale }} class="absolute inset-x-2 top-2 h-8 rounded-lg bg-green-100 border border-green-200" />
        <div className="p-1 font-medium relative z-10 space-y-3">
          <div>DuckDuckGo search</div>
          <div>Tab actions</div>
          <div>Google search</div>
        </div>
      </motion.div>
      <motion.div style={{ opacity: tabActionsOpacity, y: tabActionsY }} class="absolute top-full mt-1 left-0 right-0 rounded-md bg-white shadow-xl border border-gray-300 overflow-hidden">
        <div class="absolute bg-green-100 border border-green-200 top-9 left-2.5 right-2.5 rounded-lg h-12" />
        <div class="relative z-10">
          <div class="uppercase bg-gray-100 px-5 py-1 text-sm tracking-wide text-gray-600 font-semibold">Current Tab</div>
          <div class="flex px-5 py-4 items-center">
            <span class="w-4 h-4 leading-4">➡️</span>
            <div class="ml-5 flex flex-col">
              <span class="font-semibold text-lg">Forward Navigate</span>
            </div>
          </div>
          <div class="flex px-5 py-4 items-center">
            <span class="w-4 h-4 leading-4">⬅️</span>
            <div class="ml-5 flex flex-col">
              <span class="font-semibold text-lg">Back Navigate</span>
            </div>
          </div>
          <div class="flex px-5 py-4 items-center">
            <span class="w-4 h-4 leading-4">❌</span>
            <div class="ml-5 flex flex-col">
              <span class="font-semibold text-lg">Close Tab</span>
            </div>
          </div>
          <div class="border-t border-gray-100 px-5 py-1.5 text-gray-500 font-medium text-xs flex justify-end space-x-4">
            <div class="flex items-center space-x-0.5">
              <IconArrowsSort size={17} className="text-gray-600" />
              <span>to navigate</span>
            </div>
            <div class="flex items-center space-x-0.5">
              <IconCornerDownLeft size={18} className="text-gray-600" />
              <span>to select</span>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export {
  FeaturePluginsResult,
  FeaturePluginsInfo,
};
